import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "calendar-1" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 3.75,
			width: 22.5,
			height: 19.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 6,
			x2: 6.75,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 17.25,
			y1: 6,
			x2: 17.25,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.25,
			y: 14.25,
			width: 4.5,
			height: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 9.75,
			x2: 14.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 9.75,
			y: 9.75,
			width: 9,
			height: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 14.25,
			x2: 18.75,
			y2: 14.25
		})
	]
});
export default SvgCalendar1;
